import React from 'react'

import HoverTooltip from '../../../../components/HoverTooltip'
import { ContractCountAndSum } from '../types'

type Props = {
    theme: string
}

const PerformanceContractHeader: React.FC<Props> = ({ theme }) => {
    const fmt = (n: number | undefined) =>
        typeof n === 'number' ? n.toLocaleString('ru-RU') : 'Нет данных'

    return (
        <div className=" h-24 mx-6 flex flex-row gap-x-5">
            <div className="w-44 my-auto content-center">
                <p className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A]">
                    Подразделение
                </p>
                <p className="text-xs text-[#181818] dark:text-[#FFFFFF]">
                    Управление закупок
                </p>
            </div>

            {/* <div className="w-60 my-auto content-center ">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Закупки исключаемые у МСП
                </div>
                <div className="text-xs text-[#181818] dark:text-[#FFFFFF] ">0,00 ₽</div>
            </div> */}
        </div>
    )
}

export default PerformanceContractHeader
